import { v4 as uuidv4 } from "uuid";

// Shared persistence for client-side itinerary edits (whole-trip updates from
// UpdateItNew and per-day regenerations from ItineraryDayActions).
//
// Editing the shared "DEFAULT" slot must NOT overwrite what plain visitors of
// the city see (the cross-user cache-pollution rule): instead we mint a new
// UUID, save the edit under it, and return that id so the caller can navigate
// to /show/{city}/{newItinId}. A non-DEFAULT id (already a saved custom trip)
// is updated in place.
export async function saveItineraryEdit({
  city,
  itinid,
  itinerary,
}: {
  city: string;
  itinid: string;
  itinerary: string;
}): Promise<{ newItinId: string | null }> {
  const isDefault = itinid === "DEFAULT";
  const targetId = isDefault ? uuidv4() : itinid;

  await fetch("/api/save", {
    method: "POST",
    body: JSON.stringify({
      city,
      itinid: targetId,
      itinerary,
      itineraryUpdated: true,
    }),
  });

  return { newItinId: isDefault ? targetId : null };
}
